import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const MyBillingWrapper = styled.div`
    .account-menu {
        position: relative;
        margin: 0; margin-top: -1px;
        padding: 13px 0 36px 0;
        background-color: rgba(35, 31, 32, 1);
        line-height: 17px;

        ul {
            margin: 0 auto;
            display: flex;
            justify-content: space-around;
            width: 30%;
            min-width: 240px;
            max-width: 320px;

            li { list-style-type: none; display: inline-block; text-align: right; }
            li:not(:first-child) { text-align: left; }
        }
        a {
            font-family: 'Montserrat';
            font-size: 14px;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            letter-spacing: 0.08em;
            text-transform: uppercase;
        }
        a.active { color: rgba(12, 183, 148, 1); }
        // -- .account-menu
    }    
    .account-menu:after {
        position: absolute;
        right: 0; bottom: -3px; left: 0;
        display: inline-block;
        content: '';
        height: 3px;
        background-color: rgba(12,183,148,1);
        z-index: 1;
    }

    @media screen and (max-width: 767px) {
        .account-menu {
            ul {
                width: 70%;
                max-width: 300px;

                li, li:not(:first-child) { width: 50%; text-align: center; }
                a { line-height: 20px; letter-spacing: 0.06em; }
            }
        }
    }

    .main {
        margin: 0;
        padding: 0; padding-top: 44px; padding-bottom: 70px;
        background-color: rgba(243, 243, 243, 1);

        .info {
            margin: 0 auto;
            padding: 0;
            width: 100%;
            max-width: 698px;
            background-color: rgba(249, 249, 249, 1);

            > * { padding-right: 48px; padding-left: 64px ;}
            h2 {
                display: flex;
                justify-content: space-between;
                margin-top: 22px; margin-bottom: 21px;
                font-weight: 700;
                color: rgba(64, 55, 57, 1);
                letter-spacing: 0.08em;
                background-color: rgba(252, 252, 252, 1);
                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);
                text-transform: uppercase;
                
                > span { font-family: 'Montserrat'; font-size: 14px; line-height: 60px;}
                a, a span {
                    font-family: 'Montserrat';
                    font-size: 15px;
                    color: rgba(12, 183, 148, 1);
                    text-align: right;
                    letter-spacing: 0.01em;
                    text-transform: capitalize;
                    line-height: 60px;
                }
                // -- h2
            }
            
            h2:first-child + dl { padding-top: 6px; display: flex; align-items: center; }
            dl ~ dl { padding-top: 17px; }
            
            h2:first-child + dl dt {
                position: relative;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                height: 63px;
                background-color: rgba(230, 230, 230, 0.5);
                border-radius: 10px;
                
                img { height: 13px; }
            }
            dl {
                dt, dd { vertical-align: top; display: inline-block; }

                dt {
                    margin-right: 54px;
                    width: 70px;
                    font-family: 'Montserrat';
                    font-size: 14px;
                    color: rgba(35, 31, 32, 1);
                    letter-spacing: 0.01em;
                }
                dd {
                    font-family: 'Montserrat';
                    font-size: 14px;
                    font-weight: 700;
                    color: rgba(151, 151, 151, 1);
                    letter-spacing: 0.01em;
                    
                    span { display: block; }
                    span:not(:first-child) { padding-top: 7px; }
                }
                // -- dl
            }
            dl:last-child { padding-bottom: 63px; }
            // -- .info
        }
        // -- .main
    }
    
    @media screen and (max-width: 767px) {
        .main {
            padding-right: 16px; padding-left: 16px;
            .info {
                > * { padding-right: 22px; padding-left: 21px ;}

                .desktop { display: none; }

                h2 ~ dl:last-child {
                    display: flex;
                    justify-content: center;

                    dd { width: 50%; }
                }
            }
        }
    }


    .isoExampleWrapper {
        margin-top: 0;
        input { background-color: transparent; width: 100%;}
        input[type=password], input[type=text],input[type=tel],input[type=email],input[type=number] {
            &:focus, &:active {
                outline-width: 0;
            }
        }
        input[disabled] {
            border-color: rgba(216,216,216,0.6);
            color: rgba(0,0,0,0.5);
            background-color: transparent;
        }
    }

    .inputWrapper {
        padding: 0;
        text-align: left;
        
        label {
            margin-bottom: 8px;
            display: block;
            width: auto;

            span {
                display: inline-block;
                margin-left: 4px;
                border: 1px solid rgba(147, 147, 147, 1);
                border-radius: 100%;
                width: 14px;
                height: 14px;
                text-align: center;
                line-height: 14px;
                font-family: 'Montserrat';
                font-size: .7em;
                color: rgba(147, 147, 147, 1);
            }
        }

        .FormTextInput {
            margin-left: -7px;
            padding-right: 4px;

            > :first-child { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }
        }
    }

    .inputWrapper {
        padding-left: 10px;
        // padding-right: 10px;
        font-family: 'Montserrat';
        font-size: 20px;
        color: rgba(64, 55, 57, 1);
        letter-spacing: 0.03em;
        line-height: 18px;
        font-family: 'Montserrat-Light';
        font-size: 16px;

        .FormTextInput {
            height: 40px;
            width: 100%;
            max-width: 100%;
            border: 1px solid rgba(151, 151, 151, 1);
            border-radius: 20px;
            padding-left: 20px;
            display: -webkit-inline-box;
    
            div {
                margin: 8px;
                font-family: 'Montserrat';
                font-size: 14px;
                font-weight: 300;
                color: rgba(147, 147, 147, 1);
                text-align: left;
                letter-spacing: 0.07em;
            }
    
            &.noteditable {
                border-color: transparent;
            }

            input[type=password], input[type=number], input[type=text], input[type=email], input[type=tel] {
                height: 38px;                
                min-width: 9rem;
                border: none;
                //border-left: 1px solid rgba(151, 151, 151, 1);
            }
            
        }
    
        label {
            width: 242px;
            max-width: 242px;
            height: 17px;
            font-family: 'Montserrat';
            font-size: 14px;
            color: rgba(64, 55, 57, 1);
            text-align: left;
            letter-spacing: 0.04em;
            display: -webkit-inline-box;
        }
    
    }

    .card-type {
        width: 48px;
        min-width: 48px;
    }

    .btn-savechanges {
        margin: 32px 0;
        max-width: 242px;
        width: 100%;
        padding: 0;
        background-color: rgba(60,211,207,1);
        line-height: 38px;
        font-family: 'Montserrat';
        font-size: 15px;
        color: rgba(255,255,255,1);
        text-align: center;
        -webkit-letter-spacing: 0.01em;
        -moz-letter-spacing: 0.01em;
        -ms-letter-spacing: 0.01em;
        letter-spacing: 0.01em;
        border-radius: 20px;
    }
`;
export default WithDirection(MyBillingWrapper);


// WEBPACK FOOTER //
// ./src/containers/MyBilling/style.js